import { useContext, useEffect, useRef } from "react";
import Context from '../../context';
import './PoiTypeOptionsModal.scss';
import DoneIcon from "@mui/icons-material/Done";

const PoiTypeOptionsModal = ({ poiTypeItems, togglePoiType, anyPoiTypeActive, allPoiTypeActive, togglePoiCategory, id, modalPosition, setTrackListWidth, pinnedPoiIds }) => {
  const { t, itin } = useContext(Context);
  const modalRef = useRef(null);

  useEffect(()=>{
    if (!modalRef) return;
    setTrackListWidth(modalRef.current.offsetWidth);
  }, [setTrackListWidth, modalRef])

  const renderModalInner = () => {
    const showTicks = anyPoiTypeActive || poiTypeItems.some(x => pinnedPoiIds.has(x.id));
    return (
      <ul className="track-list"
          ref={modalRef}
          style={modalPosition()}>
        {
          poiTypeItems.map((t, ii) => {
            const isShown = t.active || pinnedPoiIds.has(t.id);
            return (
              <li key={ii} onClick={() => togglePoiType(!isShown, t)}>
                {showTicks && <span className={`tick ${isShown ? 'active' : ''}`}><DoneIcon /></span>}
                <span className="track-name">{t.infoLabel}</span>
              </li>
            )
          })
        }
        {poiTypeItems.length > 1 && (
          <li
            className="toggle-all"
            key="toggle-all"
            onClick={() => togglePoiType(!allPoiTypeActive, null, poiTypeItems[0].iconId)}
          >
            {t( allPoiTypeActive ? 'maps_hide_all_tracks' : 'maps_show_all_icon_title', { lng: itin.language })}
          </li>
        )}
      </ul>
    );
  };

  return (
    <>
      <div
        className="track-list-modal-background"
        onClick={event => togglePoiCategory(event, id)}
      />
      {renderModalInner()}
    </>
  );
};

export default PoiTypeOptionsModal;
